import { getTopScores } from '@db/index';
import { dummyRankingData } from '@/consts/dummyRankingData';
import { supabase } from '@/lib/supabase';

export const fetchRanking = async () => {
  if (!supabase) return;
  const data = await getTopScores(supabase, 50)
    .then((entries) => entries.filter((entry) => entry.high_score > 0))
    .catch((e) => {
      console.error(e);
      return dummyRankingData;
    });

  if (process.env.NODE_ENV === 'development') {
    const { ranking } = {
      ranking: data.map((entry) => ({
        rank: entry.rank,
        score: entry.high_score,
        name: entry.user_name,
        user_id: entry.user_id,
      })),
    };
    console.debug(
      `このデータは本番環境では出力されません。 ${JSON.stringify(ranking)}`,
    );
  }

  return data;
};
